export default __webpack_public_path__ + "static/media/currency_db_icon.c0c7fedd.svg";